import { render, staticRenderFns } from "./EditableFrame.vue?vue&type=template&id=e739b7f6&scoped=true&"
import script from "./EditableFrame.vue?vue&type=script&lang=js&"
export * from "./EditableFrame.vue?vue&type=script&lang=js&"
import style0 from "./EditableFrame.vue?vue&type=style&index=0&id=e739b7f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e739b7f6",
  null
  
)

export default component.exports